import React from 'react';
import { rhythm } from '../utils/typography';

function Divider() {
	return <hr style={{ marginBottom: rhythm(1) }} />
}

export default Divider